import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { vehicleFleetGetAccess, type VehicleFleetAccess } from '../lib/apiPhpAdapter'
import '../components/RoleSelector.css'

export default function VehicleFleetSelectRole() {
  const navigate = useNavigate()
  const { user } = useAuth()
  const [access, setAccess] = useState<VehicleFleetAccess | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    vehicleFleetGetAccess()
      .then((a) => {
        if (!cancelled) setAccess(a)
      })
      .catch((e) => {
        if (!cancelled) {
          setError(e instanceof Error ? e.message : 'Nepodařilo se načíst oprávnění')
          const isIt = user?.role === 'admin' && user?.admin_type === 'spravce_it'
          const isDirector = user?.role === 'director'
          setAccess({
            canAdmin: !!isIt,
            canFleetAdmin: !!isIt || !!isDirector,
            canDriver: !!isIt || !!isDirector,
            isItAdmin: !!isIt,
            isFleetAdmin: false,
            isDirector: !!isDirector,
            isDriver: false,
          })
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [user])

  const go = (path: string, allowed: boolean, deniedMsg: string) => {
    if (!allowed) {
      window.alert(deniedMsg)
      return
    }
    navigate(path)
  }

  return (
    <div className="role-selector">
      <div className="role-selector-container">
        <button type="button" className="back-to-roles-button" onClick={() => navigate('/intranet')}>
          ← Zpět na intranet
        </button>
        <h1>Rezervace vozidel</h1>
        <p className="subtitle">Vyberte roli, ve které chcete pokračovat</p>
        {loading ? <p className="subtitle">Načítání oprávnění…</p> : null}
        {error ? (
          <p className="subtitle" style={{ color: '#b45309' }}>
            {error}
          </p>
        ) : null}
        <div className="role-buttons">
          <button
            type="button"
            className="role-button admin-it"
            style={{ opacity: access && !access.canAdmin ? 0.55 : 1 }}
            onClick={() =>
              go(
                '/vehicle-fleet/admin',
                !!access?.canAdmin,
                'Přístup má pouze správce IT.',
              )
            }
          >
            <h2>Admin</h2>
            <p>Jmenování administrátorů autoparku</p>
            {access && !access.canAdmin ? (
              <p style={{ marginTop: 8, fontSize: '0.85rem', color: '#888' }}>Nedostupné</p>
            ) : null}
          </button>

          <button
            type="button"
            className="role-button admin"
            style={{ opacity: access && !access.canFleetAdmin ? 0.55 : 1 }}
            onClick={() =>
              go(
                '/vehicle-fleet/fleet-admin',
                !!access?.canFleetAdmin,
                'Přístup mají jmenovaní administrátoři autoparku, ředitel školy a správce IT.',
              )
            }
          >
            <h2>Administrátor autoparku</h2>
            <p>Jmenování řidičů, správa vozového parku</p>
            {access && !access.canFleetAdmin ? (
              <p style={{ marginTop: 8, fontSize: '0.85rem', color: '#888' }}>Nedostupné</p>
            ) : null}
          </button>

          <button
            type="button"
            className="role-button executor"
            style={{ opacity: access && !access.canDriver ? 0.55 : 1 }}
            onClick={() =>
              go(
                '/vehicle-fleet/driver',
                !!access?.canDriver,
                'Nejste jmenován řidičem. Jmenování provádí administrátor autoparku (IT a admin autoparku mají přístup vždy).',
              )
            }
          >
            <h2>Řidič</h2>
            <p>Rezervace, kalendář a zrušení</p>
            {access && !access.canDriver ? (
              <p style={{ marginTop: 8, fontSize: '0.85rem', color: '#888' }}>Nedostupné</p>
            ) : null}
          </button>
        </div>
      </div>
    </div>
  )
}
